export default __webpack_public_path__ + "static/media/VasudharaTal.4b68e7f7.webp";